import { render, staticRenderFns } from "./Texure_masters.vue?vue&type=template&id=2a633a47&"
import script from "./Texure_masters.vue?vue&type=script&lang=js&"
export * from "./Texure_masters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports